import * as React from 'react';

export default class AlertIcon extends React.Component<{ className?: string }, {}> {
    render() {
        return (
            <svg
                className={this.props.className}
                width="46"
                height="59"
                viewBox="0 0 46 59"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d={'M44.2945 40.4926L41.4998 37.0768C39.4503 ' +
                        '34.5305 38.2703 31.3632 38.2703 28.0716V21.7368C38.2703 ' +
                        '14.2221 32.9914 7.88737 25.9114 6.33474V3.35368C25.9114 1.49053 ' +
                        '24.4208 0 22.5577 0C20.6945 0 19.204 1.49053 19.204 3.35368V6.33474C12.124 ' +
                        '7.88737 6.84505 14.16 6.84505 21.7368V28.0716C6.84505 31.3632 5.72716 34.5305 ' +
                        '3.61558 37.0768L0.820844 40.4926C-1.10442 42.8526 0.572423 46.4547 3.61558 ' +
                        '46.4547H41.4377C44.5429 46.4547 46.2198 42.8526 44.2945 40.4926ZM30.6314 ' +
                        '50.9259C30.6314 55.3975 27.0293 58.9996 22.5577 58.9996C18.0861 58.9996 ' +
                        '14.484 55.3975 14.484 50.9259H30.6314ZM24.9684 36.0213C24.9684 37.3933 ' +
                        '23.8562 38.5055 22.4842 38.5055C21.1122 38.5055 20 37.3933 20 36.0213C20 ' +
                        '34.6493 21.1122 33.5371 22.4842 33.5371C23.8562 33.5371 24.9684 34.6493 ' +
                        '24.9684 36.0213ZM22.5 15C21.1193 15 20 16.1193 20 17.5V29.5C20 30.8807 ' +
                        '21.1193 32 22.5 32C23.8807 32 25 30.8807 25 29.5V17.5C25 16.1193 23.8807 15 22.5 15Z'}
                    fill="white"
                />
            </svg>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/AlertIcon.tsx